import type { DeviceDetailData } from 'containers/HostnameDetail/HostnameDetailContent';

export const isDeviceDetailData = (
  device: DeviceDetailData | undefined,
): device is DeviceDetailData => device !== undefined;
